export var EBallotError;
(function (EBallotError) {
    EBallotError[EBallotError["PARSE_ERROR"] = 0] = "PARSE_ERROR";
    EBallotError[EBallotError["DESERIALIZE_AUDITABLE_ERROR"] = 1] = "DESERIALIZE_AUDITABLE_ERROR";
    EBallotError[EBallotError["DESERIALIZE_HASHABLE_ERROR"] = 2] = "DESERIALIZE_HASHABLE_ERROR";
    EBallotError[EBallotError["CONVERT_ERROR"] = 3] = "CONVERT_ERROR";
    EBallotError[EBallotError["SERIALIZE_ERROR"] = 4] = "SERIALIZE_ERROR";
})(EBallotError || (EBallotError = {}));
export var IInvalidPlaintextErrorType;
(function (IInvalidPlaintextErrorType) {
    IInvalidPlaintextErrorType["Explicit"] = "Explicit";
    IInvalidPlaintextErrorType["Implicit"] = "Implicit";
    IInvalidPlaintextErrorType["EncodingError"] = "EncodingError";
})(IInvalidPlaintextErrorType || (IInvalidPlaintextErrorType = {}));
